import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNavigate, useParams } from "react-router-dom";
import { useReviewExamQuery } from "../../Redux/Apis/userExamApi";
import Loading from "../../Layouts/Loading";
import ErrorPage from "../../Layouts/Error";
import Error404 from "../../Layouts/Error404";
import { useState } from 'react';
import Dictionary from "../../Components/Dictionary";
import useDoubleClick from "../../Components/useDoubleClick";
import ExamHeader from "../../Sections/panel/review/ExamHeader";
import ExamQuestion from "../../Sections/panel/exam/Question";
import ReviewPanel from "../../Sections/panel/review/Review";
import ReviewQuestion from "../../Sections/panel/review/Question";
import { getSectionAndQuestionLabel } from "../../Sections/panel/exam/sectionLabel";

function ExamReview() {
    let {uxId,qId} = useParams();
    const navigate = useNavigate()
    if(uxId === undefined) navigate(`/panel/user-exams`)
    const userExamId = uxId ? parseInt(uxId) : 0;
    const qstId = qId ? parseInt(qId) : 1;
    if(qstId < 1) navigate(`/panel/user-exams`)

    const [showDic, setShowDic] = useState<boolean>(false);
    const [popupContent, setPopupContent] = useState<string>('');
    const [resetKey,setKey] = useState(0)
    const [ answerMode, setAnswerMode ] = useState('user')
    const [detail, setDetail] = useState(false);
    const [review, setReview] = useState(false);
    const [reviewSelectedOrder, setReviewSelectedOrder] = useState<number | null>(null);

    const { data,isLoading,isSuccess,isError } = useReviewExamQuery(userExamId, { refetchOnMountOrArgChange: true })

    const handleDoubleClick = (event: MouseEvent) => {
        const selection = window.getSelection();
        const selectedText = selection ? selection.toString().trim() : '';
        if (selectedText) {
            setPopupContent(selectedText);
            setShowDic(true);
        }
    };
    useDoubleClick(handleDoubleClick);

    const renderSectionAndQuestionLabel = (type: string, qstId: number, totalQuestions: number) => {
        const { sectionLabel, questionLabel } = getSectionAndQuestionLabel(type, qstId, totalQuestions);
        return (
            <h6 className="m-0 p-0 d-inline">
            {`Section ${sectionLabel}`} |{' '}
            <span className="fw-light">{`Question ${questionLabel}`}</span>
            </h6>
        );
    }

    if(isLoading)
        return <Loading/>

    else if(isError)
        return <ErrorPage/>

    else if(isSuccess && data) {
        return ( 
            <>
                <ExamHeader
                    title={data.exam.name} 
                    index={qstId} 
                    end={data.exam._count.Questions} 
                    info={data?.exam?.note}
                    userExam={data.userExam.id}
                    resetKey={resetKey}
                    setKey={setKey}
                    review={review}
                    setReview={setReview}
                    reviewSelectedOrder={reviewSelectedOrder}
                    setReviewSelectedOrder={setReviewSelectedOrder}
                />
                <div dir="ltr" className="p-0 m-0">
                    <div className="d-flex justify-content-between align-items-center pt-2 pb-2 m-0 px-5 border-bottom border-danger border-2">
                        <div>
                            <FontAwesomeIcon icon="check-square" className="ms-1"/>
                            {renderSectionAndQuestionLabel(data.exam.type, qstId, data.exam._count.Questions)}
                        </div>
                        {!review && (
                            <div>
                                <button className="btn btn-outline-primary ms-2" onClick={() => setDetail(true)}><FontAwesomeIcon className="align-middle" icon='eye'/> Answer Explanation</button>

                                <input type="radio" className="btn-check" onClick={() => {setAnswerMode('system');setKey(resetKey + 1)}} defaultChecked={answerMode === 'system'} name="options-outlined" id="success-outlined" autoComplete="off" />
                                <label className="btn btn-outline-success ms-2" htmlFor="success-outlined"><FontAwesomeIcon icon='check'/> Correct Answer</label>

                                <input type="radio" className="btn-check" onClick={() => {setAnswerMode('user');setKey(resetKey + 1)}} defaultChecked={answerMode === 'user'} name="options-outlined" id="primary-outlined" autoComplete="off"/>
                                <label className="btn btn-outline-secondary" htmlFor="primary-outlined"><FontAwesomeIcon icon='user'/> Your Answer</label>
                            </div>
                        )}
                    </div>
                    <div className="h-100 border rounded m-1 p-2 text-center" key={resetKey}>
                        {review ? (
                            <ReviewPanel
                                userExamId={data.userExam.id}
                                selectedOrder={reviewSelectedOrder}
                                onSelect={setReviewSelectedOrder}
                            />
                        ) : (
                            <>
                                <ExamQuestion
                                    examId={data.exam.id}
                                    qstId={qstId}
                                    userExam={data.userExam.id}
                                    resetKey={resetKey}
                                    readOnly={true}
                                    answerMode={answerMode}
                                />
                                <ReviewQuestion
                                    examId={data.exam.id}
                                    qstId={qstId}
                                    userExam={data.userExam.id}
                                    resetKey={resetKey}
                                    answerMode={answerMode}
                                    detail={detail}
                                    setDetail={setDetail}
                                />
                            </>
                        )}
                    </div>
                </div>
                {showDic && (
                    <Dictionary
                    content={popupContent}
                    onClose={() => setShowDic(false)}
                    />
                )}
            </>
        );
    }

    else return <Error404/>
}

export default ExamReview;
